<template>
  <div class="itemsWrapper">
    <template v-if="postType === 'cube'">
      <div class="tabs">
        <span :class="`tab ${tab === 'latest'?'select':''}`" @click="setTab('latest')">最新</span>
        <span class="line"></span>
        <span :class="`tab ${tab === 'essence'?'select':''}`" @click="setTab('essence')">精华</span>
        <span style="font-size:12px; color:#999999;margin-top: 3px;margin-left:5px;">精华作品将获得1声望奖励</span>
      </div>
      <p class="tip" style="color:#666666;">
        本版块所有作品采用MagicaVoxel创作，请点击下载
        <a target="_blank" href="https://static1.bcjiaoyu.com/MagicaVoxel-0.99.4.1-alpha-win64.zip">Windows版</a> 或
        <a target="_blank" href="https://static1.bcjiaoyu.com/MagicaVoxel-0.99.4.2-alpha-macos.zip">Mac版</a>。
        <a target="_blank" href="https://www.coding61.com/community/#/post/48679">使用教程1</a>
        <a target="_blank" href="https://www.coding61.com/community/#/post/48694" style="margin-left:10px;">使用教程2</a>
      </p>
    </template>

    <template v-if="postType === 'piskel'">
      <div class="tabs">
        <span :class="`tab ${tab === 'latest'?'select':''}`" @click="setTab('latest')">最新</span>
        <span class="line"></span>
        <span :class="`tab ${tab === 'essence'?'select':''}`" @click="setTab('essence')">精华</span>
        <span style="font-size:12px; color:#999999;margin-top: 3px;margin-left:5px;">精华作品将获得1声望奖励</span>
      </div>
      <p class="tip" style="color:#666666;">
        本版块所有作品采用Piskel 创作，请点击<a target="_blank" href="https://piskel.coding61.com" style="margin-right:5px; color: rgb(107, 69, 225);">打开地址</a>
        <a target="_blank" href="https://static1.bcjiaoyu.com/piskel_video/%E5%83%8F%E7%B4%A0%E8%89%BA%E6%9C%AF%E5%9C%88%E6%95%99%E7%A8%8B1.mp4" style="color: rgb(107, 69, 225);">使用教程1</a>
        <a target="_blank" href="https://static1.bcjiaoyu.com/piskel_video/%E5%83%8F%E7%B4%A0%E8%89%BA%E6%9C%AF%E5%9C%88%E6%95%99%E7%A8%8B2.mp4" style="margin-left:10px;color: rgb(107, 69, 225);">使用教程2</a>
      </p>
    </template>

    <template v-if="postType === 'video'">
      <div class="tabs">
        <span :class="`tab ${tab === 'latest'?'select':''}`" @click="setTab('latest')">最新</span>
        <span class="line"></span>
        <span :class="`tab ${tab === 'essence'?'select':''}`" @click="setTab('essence')">精华</span>
        <span style="font-size:12px; color:#999999;margin-top: 3px;margin-left:5px;">精华视频将获得2声望奖励，上首页视频将获得10声望奖励</span>
      </div>
    </template>
    
    <PostItem
      v-for="item in data"
      :key="item.pk"
      :dic="item"
      :owner-info="ownerInfo"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import PostItem from "./components/PostItem.vue";

import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "PostList",
  components: {
    PostItem
  },
  props: {
    // 帖子类型，默认全部，common(朋友圈)、work(作品圈)、oj(oj圈)
    postType: {
      type: String,
      default: ""
    },
    // 关注类型，默认全部，all(全部))、follow(关注的人)
    followType: {
      type: String,
      default: "all"
    },
    // 当前登录用户的信息
    ownerInfo: {
      type: Object,
      default: null
    },
    // 从哪里加载的
    from: {
      type: String,
      default: 'home'
    }
  },
  data () {
    return {
      //帖子过滤类型
      tab: 'latest',
    };
  },
  watch: {
    // postType(newVal, oldVal) {
    //   console.log(newVal, oldVal);
    //   if (newVal !="" && newVal !== oldVal) {
    //     console.log("改变了帖子的类型：重新请求", newVal)
    //     this.loadData("reset", newVal, this.followType)
    //   }
    // },
    // followType(newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     console.log("改变了关注的类型：重新请求", newVal)
    //     this.loadData("reset", this.postType, newVal)
    //   }
    // }
  },
  computed: {
    ...mapState({
      load_more_items: state => state.community.load_more
    }),
    ...mapGetters({
      data: CommunityTypes.GETTER_LIST_POST
    })
  },

  methods: {
    ...mapActions({
      fetchLoadPosts: CommunityTypes.FETCH_LIST_POST,
      fetchCreateEvent: CommunityTypes.FETCH_CREATE_EVENT,
      fetchLikeEvent: CommunityTypes.FETCH_LIKE_EVENT,
      fetchDeleteEvent: CommunityTypes.FETCH_DELETE_EVENT,
      fetchFlowerEvent: CommunityTypes.FETCH_FLOWER_EVENT,
      fetchForwardEvent: CommunityTypes.FETCH_FORWARD_EVENT,
      fetchFollowEvent: CommunityTypes.FETCH_FOLLOWERS_EVENT,
      fetchStickyEvent: CommunityTypes.FETCH_STICKY_EVENT,
      fetchEssenceEvent: CommunityTypes.FETCH_ESSENCE_EVENT,
      fetchHomeVideoEvent: CommunityTypes.FETCH_HOME_VIDEO_EVENT,
    }),
    setTab (type) {
      if (type === this.tab) return
      this.tab = type;
      this.loadData()
    },

    handleScroll (e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more_items) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.loadData("next", this.postType, this.followType)
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    },
    /*
    handleScroll(e) {
      // console.log(e);
      let height = e.target.offsetHeight;
      let scrollHeight = e.target.scrollHeight;
      let scrollTop = e.target.scrollTop;
      // console.log(height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop) {
        //当内容高度小于可视高度+滚动条的高度时，触发事件
        console.log("加载新数据");
        if (this.load_more_items) {
          console.log("还有更多数据，到达底部，继续加载新数据");
          this.fetchLoadPosts({type:"next"});
        } else {
          console.log("没有新数据了");
          // this.showToast({ message: "没有更多数据了" });
        }
      } else {
        console.log("没到底部");
      }
    },
    */

    loadData (type = "reset", postType = this.postType, followType = this.followType, search = "") {
      let dic = {
        type: type
      }
      if (this.from === 'profile') {
        // 个人主页
        let user = this.$route.params.user
        dic["user_id"] = user;
      } else if (this.from === 'company') {
        // 公司会议室
        let company_id = this.$route.params.company_id;
        dic["company_id"] = company_id;
      } else if(this.from === 'school'){
        // 学校会议室
        let school_id = this.$route.params.school_id;
        dic["school_id"] = school_id;
      } else if (postType === 'science') {
        // 科普圈
        dic["owner"] = "18701257897"; //18701257897
      } else if (postType === 'move') {
        // 搬运圈
        dic["owner"] = '88820190449'; //88820190449
      } else if (postType === 'mago') {
        // mago 杂志
        dic["owner"] = '88820190450'; //88820190450
      } else if (postType === 'contest') {
        // 竞赛圈
        dic["owner"] = '18030189555'; //18030189555
      } else {
        // 朋友圈、作品圈
        dic["post_type"] = postType;
        dic["follow_type"] = followType;
        dic["page_size"] = 15
      }
      if (search) {
        dic["search"] = search;
      }
      if (this.tab === 'essence') {
        dic["is_essence"] = true
      }
      this.fetchLoadPosts(dic);

    },
    //-------------postItem 组件的回调函数
    // 发帖子，对帖子评论，对评论回复
    publish (type, data) {
      data["type"] = type;
      // console.log(data);
      this.fetchCreateEvent(data);
    },
    // 点赞
    likeEvent (type, data) {
      data["type"] = type;
      this.fetchLikeEvent(data);
    },
    // 置顶帖子和取消
    stickyPost (type, data) {
      data["type"] = type;
      this.fetchStickyEvent(data);
    },
    // 精华帖子和取消
    essencePost (type, data) {
      data["type"] = type;
      this.fetchEssenceEvent(data);
    },
    // 上首页帖子和取消
    homePost(type, data){
      data["type"] = type;
      this.fetchHomeVideoEvent(data);
    },
    // 删除帖子、评论、回复
    deleteEvent (type, data) {
      data["type"] = type;
      this.fetchDeleteEvent(data);
    },
    // 帖子送花
    flowerEvent (type, data) {
      data["type"] = type;
      this.fetchFlowerEvent(data);
    },
    // 帖子转发到朋友圈
    forwardEvent (type, data) {
      data["type"] = type;
      this.fetchForwardEvent(data);
    },
    // 关注/取关事件
    followEvent (type, data) {
      data["type"] = type;
      this.fetchFollowEvent(data);
    },
    // 加载更多评论事件
    loadMoreComment (post_id) {
      this.$router.push(`/post/${post_id}`);
    }
  },
  created () {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted () {
    if (this.from === 'profile') {
      // 因为个人主页的 posttype 一直不会变
      console.log("初始请求[帖子][profile]")
      this.loadData("reset", "", "");
    } else {
      let postType = "work"
      if (this.$route.query.tag) {
        postType = this.$route.query.tag;
      }
      console.log("初始请求[帖子][home]", postType)
      this.loadData("reset", postType, this.followType)
    }
  }
};
</script>

<style lang="less" scoped>
.itemsWrapper {
  width: 100%;
  // padding-top: 30px;
  min-height: 600px;
}
.profile{
  padding-top: calc(1.5rem - 10px);
}
.tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 25px;
  margin-left: 15px;
  .tab {
    color: #999999;
    cursor: pointer;
    &.select {
      color: #ef8132;
    }
  }
  .line {
    margin: 0 10px;
    width: 1px;
    height: 10px;
    background-color: #999999;
  }
}
.tip {
  color: #6b45e1;
  font-size: 14px;
  margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 15px;
}
</style>
